import { render, staticRenderFns } from "./MinigamesPage.vue?vue&type=template&id=70ddceec&scoped=true"
import script from "./MinigamesPage.vue?vue&type=script&lang=js"
export * from "./MinigamesPage.vue?vue&type=script&lang=js"
import style0 from "./MinigamesPage.vue?vue&type=style&index=0&id=70ddceec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ddceec",
  null
  
)

export default component.exports